import { Button, Card, Col, Row } from "reactstrap";
import { trackEvent } from "utils/analytics";

// Primary conversion CTA for marketing pages: sends the visitor to the
// dashboard signup. Kept in one place so every demo/pricing page points at
// the same trial URL.
export const getTrialUrl = (plan) => {
    const base = (process.env.REACT_APP_ENDPOINT_DASHBOARD || "").replace(/\/+$/, "");
    const url = `${base}/register`;
    return plan ? `${url}?plan=${encodeURIComponent(plan)}` : url;
};

export default function TrialCallout({
    headline = "Try it on your store today",
    subline = "Start your 14-day free trial — get up and running in less than 10 minutes with our Javascript SDK and REST API.",
    primaryLabel = "Start Free Trial",
    plan = null
}) {
    return (
        <Card className="bg-gradient-success shadow-lg border-0">
          <div className="p-5">
            <Row className="align-items-center">
              <Col lg="8">
                <h3 className="text-white">
                  {headline}
                </h3>
                <p className="lead text-white mt-3">
                  {subline}
                </p>
              </Col>
              <Col className="ml-lg-auto" lg="3">
                <Button
                  block
                  className="btn-white"
                  color="default"
                  href={getTrialUrl(plan)}
                  size="lg"
                  onClick={() => trackEvent('conversion', 'start_trial_click', plan || headline)}
                >
                  {primaryLabel}
                </Button>
                <div className="text-center mt-3">
                  <a className="text-white font-weight-bold" href="/pricing">
                    <small>View Pricing</small>
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </Card>)
}
